import React from 'react'
import { Grid, GridCell } from '@mobi/component-library/Legacy/Grid'
import { observeImmutable } from '@core/Components/HOCs'
import { toOdds } from '@core/Utils/odds/odds'
import { BettingV2CommandStateRecord, state$ as commandState$ } from '../../Commands/driver'
import {
  MarketMoverContainer as MarketMoversContainer,
  MarketMoversDividend,
  MarketMoversHeader,
} from './MarketMovers.styles'

export interface MarketMoversDividendProps {
  MinutesToAst: number
  Dividend: number | null
}

interface MarketMoversWrapperComponentProps {
  showMarketMovers: boolean
  starter: MarketMoversStarterProps
}

interface MarketMoversStarterProps {
  isScratched: boolean
  marketMovers: MarketMoversDividendProps[]
}

export const MarketMovers = observeImmutable<BettingV2CommandStateRecord, MarketMoversStarterProps>(
  commandState$,
  ({ record, ...props }) => {
    const { showMarketMovers } = record
    return <MarketMoversWrapperComponent showMarketMovers={showMarketMovers} starter={props} />
  }
)

export const MarketMoversWrapperComponent = ({
  showMarketMovers,
  starter,
}: MarketMoversWrapperComponentProps): JSX.Element | null => {
  const { isScratched, marketMovers } = starter

  if (!showMarketMovers) return null

  if (isScratched || marketMovers.length === 0 || !marketMovers.some(m => m.Dividend != null)) {
    return null
  }

  return <MarketMoversComponent marketMovers={marketMovers} />
}

const MarketMoversComponent = ({
  marketMovers,
}: {
  marketMovers: MarketMoversDividendProps[]
}): JSX.Element => {
  const listItems = marketMovers.map(marketMover => (
    <GridCell width='15%' valign='bottom' align='center' key={marketMover.MinutesToAst}>
      <MarketMoverHeader
        dividendIndex={marketMover.MinutesToAst}
        header={marketMover.MinutesToAst}
      />
      <MarketMoverPointDividend
        dividendIndex={marketMover.MinutesToAst}
        dividend={marketMover.Dividend}
      />
    </GridCell>
  ))

  return (
    <MarketMoversContainer data-testid='market-movers-container'>
      <Grid>
        <GridCell width='15%' />
        {listItems}
      </Grid>
    </MarketMoversContainer>
  )
}

const MarketMoverPointDividend = ({
  dividendIndex,
  dividend,
}: {
  dividendIndex: number
  dividend: number | null
}): JSX.Element => {
  const displayDividend: string = dividend === null ? '-' : toOdds(dividend)
  return (
    <MarketMoversDividend data-tid-dividend-index={dividendIndex}>
      {displayDividend}
    </MarketMoversDividend>
  )
}

const MarketMoverHeader = ({
  dividendIndex,
  header,
}: {
  dividendIndex: number
  header: number
}): JSX.Element => {
  return <MarketMoversHeader data-tid-dividend-index={dividendIndex}>{header}m</MarketMoversHeader>
}
